module.exports = __webpack_public_path__ + "media/1.01e3fe52.mp3";